import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { videos as assetsVideos } from '../../assets';
import { GridBackground } from '../GridBackground';

const RedSocialSection = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const firstVideoRef = useRef(null);

  useEffect(() => {
    if (firstVideoRef.current) {
      firstVideoRef.current.currentTime = 3;
      firstVideoRef.current.pause();
    }
  }, []);

  // Lock body scroll and handle escape key when modal is open
  useEffect(() => {
    if (selectedVideo) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      const handleKeyDown = (e) => {
        if (e.key === 'Escape') setSelectedVideo(null);
      };
      window.addEventListener('keydown', handleKeyDown);
      return () => {
        document.body.style.overflow = originalOverflow;
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [selectedVideo]);

  const tiktokProfile = {
    username: '@energyhco',
    followers: '2618',
    likes: '61.4K'
  };

  const videos = [
    {
      id: 1,
      src: assetsVideos.tiktok1,
      desc: '🏋️🏋️‍♀️!!! ENERGYM 100% FIERREROS 🏋️🏋️‍♀️!!',
      likes: '389',
      comments: '14',
      views: '21.3k',
      hashtags: '#navidad #gym #retos #energy #huanuco #fierreros',
      userComments: [
        { user: 'Daga', text: 'créditos 💪' },
        { user: 'Stiven', text: 'Qué buena vibra tiene el gym' },
        { user: 'LuciaF', text: 'El mejor gym 💪🏽' },
        { user: 'Marcos_', text: 'Jajaja buenísimo el video, a quemar el panetón!' },
        { user: 'Andrea', text: 'Energy siempre con las mejores dinámicas.' },
        { user: 'Stephanie', text: '💪🏼💪🏼💪🏼' }
      ]
    },
    {
      id: 2,
      src: assetsVideos.tiktok2,
      desc: 'Sabias que las fuerzas de tus piernas podrian predecir tu longevidad? Fortalece tus piernas para una vida mas larga y saludable.',
      likes: '75',
      comments: '15',
      views: '1.5k',
      hashtags: '#legday #squats #fitness #gymlife #workout',
      userComments: [
        { user: 'Maria', text: 'Las sentadillas libres son lo mejor! 🔥' },
        { user: 'Carlos', text: 'Buen dato sobre la longevidad, a entrenar pierna!' }
      ]
    },
    {
      id: 3,
      src: assetsVideos.tiktok3,
      desc: 'Transformación de nuestros alumnos en 90 días. La constancia vence al talento.',
      likes: '1222',
      comments: '128',
      views: '17.9k',
      hashtags: '#transformation #motivation #nopainnogain #results',
      userComments: [
        { user: 'Strong', text: 'Increíble cambio! 👏' },
        { user: 'PeCausa', text: 'La constancia es todo.' }
      ]
    },
    {
      id: 4,
      src: assetsVideos.tiktok4,
      desc: 'La Fuerza es la justicia la Fuerza lo supera todo 🗣️-Realiza entrenamientos de fuerza para obtener sus beneficios',
      likes: '105',
      comments: '12',
      views: '1.9k',
      hashtags: '#Gym #fuerza #gymtok #contenido #humor #metabolismo #ciencia #DatosCuriosos #contenido #SabiasQue #videoviral #fypシ゚',
      userComments: [
        { user: 'JulianJulian', text: 'Totalmente de acuerdo, el equilibrio es clave 🙌' },
        { user: 'DonDa', text: 'Gran mensaje, a veces olvidamos la mente por el cuerpo.' }
      ]
    }
  ];

  return (
    <section
      className="relative py-14 sm:py-20 px-4 md:px-8 border-t border-b border-neutral-300/80 overflow-hidden select-none"
      style={{ backgroundColor: '#e7e1d9' }}
    >
      <GridBackground
        gridColor="rgba(100, 95, 90, 0.16)"
        mask={false}
      />
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 sm:mb-12 gap-5">
          <div>
            <h2 className="anton-font text-3xl sm:text-5xl md:text-6xl lg:text-7xl text-neutral-900 uppercase leading-tight tracking-normal mb-2 sm:mb-3">
              <span className="text-blue-600">ENERGY HUÁNUCO</span> EN ACCIÓN
            </h2>
            <p className="text-neutral-700 text-xs sm:text-base max-w-xl font-medium">
              El día a día, retos, técnicas y el mejor ambiente fierrero directamente desde nuestra comunidad.
            </p>
          </div>

          {/* Profile Card & Follow CTA */}
          <div className="w-full sm:w-auto flex items-center justify-between sm:justify-start gap-3 sm:gap-4 bg-neutral-900/95 border border-neutral-800 rounded-xl sm:rounded-2xl p-2.5 sm:p-3 pr-3 sm:pr-4 shadow-xl backdrop-blur-md">
            <div className="flex items-center gap-2.5 sm:gap-3">
              <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-lg sm:rounded-xl bg-black border border-neutral-700 flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </div>
              <div>
                <p className="text-white font-bold text-xs sm:text-sm leading-tight">{tiktokProfile.username}</p>
                <p className="text-neutral-400 text-[10px] sm:text-xs mt-0.5">{tiktokProfile.followers} seguidores • {tiktokProfile.likes} likes</p>
              </div>
            </div>

            <button
              onClick={() => window.open('https://www.tiktok.com/@energyhco', '_blank')}
              className="inline-flex items-center gap-1.5 sm:gap-2 bg-white text-black hover:bg-neutral-200 px-3.5 py-1.5 sm:px-5 sm:py-2.5 rounded-lg sm:rounded-xl font-semibold text-xs sm:text-sm tracking-wide transition-all duration-300 hover:scale-[1.02] shadow-md ml-auto"
            >
              <span>Seguir</span>
              <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Grid de Videos */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 max-w-5xl mx-auto">
          {videos.map((video) => (
            <div
              key={video.id}
              role="button"
              tabIndex={0}
              onClick={() => setSelectedVideo(video)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedVideo(video);
                }
              }}
              onMouseEnter={(e) => {
                const vid = e.currentTarget.querySelector('video');
                if (vid) vid.play().catch(() => { });
              }}
              onMouseLeave={(e) => {
                const vid = e.currentTarget.querySelector('video');
                if (vid) {
                  vid.pause();
                  if (video.id === 1) vid.currentTime = 3;
                  else vid.currentTime = 0;
                }
              }}
              className="group relative aspect-[9/16] w-full bg-neutral-950 rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer border border-neutral-800 hover:border-neutral-600 transition-all duration-500 hover:-translate-y-1.5 shadow-xl sm:shadow-2xl focus:outline-none focus:ring-2 focus:ring-neutral-400"
              aria-label={`Ver video: ${video.desc}`}
            >
              {/* Video */}
              {video.src && (
                <video
                  ref={video.id === 1 ? firstVideoRef : undefined}
                  src={video.src}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 sm:group-hover:scale-105"
                  muted
                  loop
                  playsInline
                  preload="metadata"
                />
              )}

              {/* Degradado para legibilidad */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-90 group-hover:opacity-80 transition-opacity duration-300 pointer-events-none" />

              {/* Badge superior con Views */}
              <div className="absolute top-2 sm:top-3.5 left-2 sm:left-3.5 z-20">
                <div className="inline-flex items-center gap-1 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full bg-black/60 backdrop-blur-md border border-white/10 text-white text-[10px] sm:text-xs font-semibold">
                  <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-neutral-300" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                  <span>{video.views}</span>
                </div>
              </div>

              {/* Botón de reproducción en el centro al hacer hover */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
                <div className="w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-black/60 backdrop-blur-md border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 scale-90 group-hover:scale-100 shadow-xl">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white translate-x-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>

              {/* Información inferior */}
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5 z-20 text-left">
                <p className="text-white text-[10px] sm:text-sm font-medium line-clamp-2 leading-snug sm:leading-relaxed mb-2 sm:mb-3 group-hover:text-neutral-200 transition-colors">
                  {video.desc}
                </p>

                {/* Métricas: Likes & Comments */}
                <div className="flex items-center gap-3 sm:gap-4 text-neutral-400 text-[10px] sm:text-xs font-medium border-t border-white/10 pt-2">
                  <span className="inline-flex items-center gap-1 sm:gap-1.5 text-white">
                    <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-neutral-400" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                    </svg>
                    {video.likes}
                  </span>
                  <span className="inline-flex items-center gap-1 sm:gap-1.5 text-neutral-300">
                    <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-neutral-400" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z" />
                    </svg>
                    {video.comments}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal de Reproducción Detallada */}
        {selectedVideo && typeof document !== 'undefined' && createPortal(
          <div
            className="fixed inset-0 z-[99999] flex items-center justify-center p-3 sm:p-4 bg-black/90 backdrop-blur-md"
            onClick={() => setSelectedVideo(null)}
          >
            <div
              className="bg-[#141414] w-full max-w-4xl h-[90vh] md:h-[80vh] rounded-3xl overflow-hidden flex flex-col md:flex-row border border-neutral-800 shadow-2xl"
              onClick={e => e.stopPropagation()}
            >
              {/* Video Area */}
              <div className="h-[50%] md:h-auto md:flex-1 bg-black flex items-center justify-center relative">
                {selectedVideo.src && (
                  <video
                    src={selectedVideo.src}
                    className="w-full h-full object-contain"
                    controls
                    autoPlay
                  />
                )}
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="absolute top-4 right-4 md:hidden text-white bg-black/60 rounded-full p-2"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Info Area */}
              <div className="w-full md:w-96 flex-1 md:flex-none bg-[#161616] p-5 md:p-6 flex flex-col border-l border-neutral-800 min-h-0">
                <div className="flex items-center justify-between mb-5 flex-shrink-0">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-black border border-neutral-700 flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-bold text-white text-sm">{tiktokProfile.username}</p>
                      <p className="text-xs text-neutral-400">Audio original</p>
                    </div>
                  </div>
                  <button onClick={() => setSelectedVideo(null)} className="hidden md:block text-neutral-400 hover:text-white p-1">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="flex-1 overflow-y-auto min-h-0 pr-2 custom-scrollbar">
                  <p className="text-neutral-200 text-sm leading-relaxed mb-4">
                    {selectedVideo.desc}
                    <br /><br />
                    <span className="text-blue-400 text-xs">{selectedVideo.hashtags}</span>
                  </p>

                  <div className="flex items-center gap-6 py-4 border-t border-neutral-800">
                    <div className="flex items-center gap-2">
                      <div className="p-2 bg-neutral-900 rounded-lg">
                        <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                        </svg>
                      </div>
                      <span className="text-sm font-bold text-white">{selectedVideo.likes}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="p-2 bg-neutral-900 rounded-lg">
                        <svg className="w-4 h-4 text-neutral-300" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z" />
                        </svg>
                      </div>
                      <span className="text-sm font-bold text-white">{selectedVideo.comments}</span>
                    </div>
                  </div>

                  {/* Comments */}
                  <div className="space-y-3.5 mt-4">
                    <p className="text-[11px] font-bold text-neutral-400 uppercase tracking-wider">Comentarios recientes</p>

                    {selectedVideo.userComments && selectedVideo.userComments.map((comment, index) => (
                      <div key={index} className="flex gap-3 items-start bg-neutral-900/50 p-3 rounded-xl border border-neutral-800/60">
                        <div className="w-7 h-7 rounded-lg bg-neutral-800 flex items-center justify-center text-xs font-bold text-neutral-300 flex-shrink-0">
                          {comment.user.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <p className="text-xs font-semibold text-neutral-300">{comment.user}</p>
                          <p className="text-xs text-neutral-400 mt-0.5 leading-snug">{comment.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
      </div>
    </section>
  );
};

export default RedSocialSection;
